import { Alert, Button, Icons, Input, Modal, Space, Typography } from "@pankod/refine-antd";
import { useState } from "react";

interface Props {
  open: boolean;
  password: string;
  onClose: () => void;
}

export function PasswordRevealModal({ open, password, onClose }: Props) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(password).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleClose = () => {
    setCopied(false);
    onClose();
  };

  return (
    <Modal
      title="Senha gerada"
      visible={open}
      onCancel={handleClose}
      footer={
        <Button type="primary" onClick={handleClose}>
          Fechar
        </Button>
      }
      closable={false}
      maskClosable={false}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Alert
          type="warning"
          message="Esta senha não será exibida novamente. Copie antes de fechar."
          showIcon
        />
        <Typography.Text strong>Senha:</Typography.Text>
        <Space>
          <Input.Password
            value={password}
            readOnly
            visibilityToggle={true}
            style={{ width: 280 }}
          />
          <Button
            icon={copied ? <Icons.CheckOutlined /> : <Icons.CopyOutlined />}
            onClick={handleCopy}
            type={copied ? "primary" : "default"}
          >
            {copied ? "Copiado!" : "Copiar"}
          </Button>
        </Space>
      </Space>
    </Modal>
  );
}
